define('OutSystems/ReactView/KeyboardKey',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.KeyboardKey = void 0;
    var KeyboardKey;
    (function (KeyboardKey) {
        KeyboardKey["SPACE"] = " ";
        KeyboardKey["ENTER"] = "Enter";
        KeyboardKey["ESCAPE"] = "Escape";
    })(KeyboardKey || (exports.KeyboardKey = KeyboardKey = {}));
});
//# sourceMappingURL=KeyboardKey.js.map;
